import { NotificationsNone } from "@mui/icons-material";
import { FONT_WEIGHTS, Icon, IconButton, Row, Span, TextLink, Tooltip } from "@bridgesplit/ui";

import { DESKTOP_PADDING, NAV_BREAKPOINT, NAV_ICON_BUTTON_SX } from "./constants";
import NavOptions from "./NavOptions";
import ProfileButton from "./ProfileButton";
import { useNavOptions } from "./util";
import { NavPoints } from "./points";

export default function DesktopNavbar() {
    const navOptions = useNavOptions();

    return (
        <Row
            spaceBetween
            sx={{
                p: DESKTOP_PADDING,
                [NAV_BREAKPOINT.below]: { display: "none" }
            }}
        >
            <Row spacing={1}>
                <TextLink variant="h4" textSx={{ width: "max-content", fontWeight: FONT_WEIGHTS.logo }} to="/">
                    <Icon type="logo-outer" />
                </TextLink>
                <Row>
                    <NavOptions options={navOptions} />
                </Row>
            </Row>

            <Row spacing={1}>
                <NotificationButton />
                <NavPoints />
                <ProfileButton />
            </Row>
        </Row>
    );
}

function NotificationButton() {
    return (
        <Tooltip title="Notifications returning soon!">
            <Span>
                <IconButton disabled sx={NAV_ICON_BUTTON_SX} jsxIcon={<NotificationsNone />} />
            </Span>
        </Tooltip>
    );
}
